<template>
  <v-card color="secondary">
    <v-card-text>
      <v-row
        ><v-col class="text-left" align-self="center"
          ><span class="price-text">{{
            $cms.get(content, 'regular_shipment')
          }}</span></v-col
        ><v-col align-self="center">
          <currency :key="regularPrice" class="strikethrough">{{
            regularPrice
          }}</currency></v-col
        ></v-row
      >
      <v-row
        ><v-col class="text-left" align-self="center"
          ><span class="price-text">{{
            $cms.get(content, 'tam_shipment')
          }}</span></v-col
        ><v-col align-self="center"
          ><v-alert
            dense
            color="tertiary"
            elevation="9"
            class="ma-0 price-value"
            ><b
              ><currency :key="tamPrice">{{ tamPrice }}</currency></b
            ></v-alert
          ></v-col
        ></v-row
      ></v-card-text
    ></v-card
  >
</template>

<script>
import priceJSON from '@/data/json/homepage/savings/price.json'
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      content: priceJSON.data
    }
  },
  computed: {
    regularPrice() {
      return this.value * 0.85
    },
    tamPrice() {
      return this.value * 0.8
    }
  }
}
</script>

<style lang="scss" scoped>
.price-text {
  font-size: 1.25rem;
  color: var(--v-primary-base);
}
.price-value {
  font-size: 1.75rem;
  font-weight: bold;
}
.strikethrough {
  position: relative;
  &::before {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    right: 0;
    border-top: 3px solid;
    color: red;
    border-color: inherit;
    -webkit-transform: rotate(-25deg);
    -moz-transform: rotate(-25deg);
    -ms-transform: rotate(-25deg);
    -o-transform: rotate(-25deg);
    transform: rotate(-25deg);
  }
}
</style>
